module.exports = __webpack_public_path__ + "img/workout-notebook_B095R7HFP1.1cfa2a11.jpg";